import React from "react";
import "../styles/BotCta.scss";

export default function BotCta() {
  return (
    <section className="botcta">
      <div className="botcta__wrap">
        <div className="botcta__container">
          <h3 className="botcta__title">
            <span className="botcta__dot" aria-hidden="true" />
            Chatea con nuestro bot
          </h3>

          <p className="botcta__text">
            Resuelve tus dudas, déjanos tus datos y solicita la cotización de tu
            proyecto de vidrio y aluminio.
          </p>

          <span className="botcta__badge">
            Atención 24/7 · CDMX y Área Metropolitana
          </span>
        </div>
      </div>
    </section>
  );
}
